import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";

import {
  DataTable,
  Loadable,
  IconButton,
  TextToMask
} from "components/support";

class CompanyDataTableView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        id: "fiscal_informations.legal_name",
        accessor: "fiscal_informations.legal_name",
        Header: "Razão Social"
      },
      {
        id: "name",
        accessor: "name",
        Header: "Nome Fantasia"
      },
      {
        id: "fiscal_informations.cnpj",
        Header: "CNPJ",
        align: "center",
        Cell: props => {
          const hasFiscalInformations = !!props.original.fiscal_informations;
          const hasCnpj =
            !!hasFiscalInformations &&
            !!props.original.fiscal_informations.cnpj;
          const value = !!hasCnpj
            ? props.original.fiscal_informations.cnpj
            : "";
          return <TextToMask value={value} mask="cnpj" />;
        }
      },
      {
        id: "email",
        accessor: "email",
        Header: "E-mail"
      },
      {
        id: "phone",
        Header: "Telefone",
        align: "center",
        Cell: props => <TextToMask value={props.original.phone} mask="phone" />
      },
      {
        id: "actions",
        Header: "Ações",
        align: "right",
        filterable: false,
        sortable: false,
        Cell: props => (
          <div>
            <IconButton
              mini
              icon="search"
              onClick={() =>
                this.props.redirectTo("app.registration.company.view", {
                  companyUuid: props.original.uuid
                })
              }
            />
            <IconButton
              mini
              icon="mode_edit"
              onClick={() =>
                this.props.redirectTo("app.registration.company.edit", {
                  companyUuid: props.original.uuid
                })
              }
            />
          </div>
        )
      }
    ]
  };

  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      await this.presenter.onFilterChange(nextProps.filter);
    }
  }

  handleDataTableChange = ({ field, value }) => {
    this.presenter.onOrderChange(field, value);
  };

  handlePageChange = page => {
    this.presenter.onPageChange(page + 1);
  };

  render() {
    const { content, pagination, order, loading } = this.props.viewModel;

    return (
      <Row>
        <Col className="company__content text-right company_qtd" xs={12}>
          <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
            {pagination.total} empresa(s) encontrada(s)
          </h3>
        </Col>
        <Col xs={12}>
          <Paper elevation={1} className="user__content">
            <Loadable loading={loading}>
              <DataTable
                manual
                filterable={false}
                defaultSorted={[
                  {
                    id: "trading_name",
                    desc: false
                  }
                ]}
                resultSet={content}
                total={pagination.total}
                perPage={pagination.perPage}
                page={pagination.currentPage}
                config={this.config}
                onChange={this.handleDataTableChange}
                orderField={order.field}
                orderDirection={order.direction}
                onPageChange={this.handlePageChange}
              />
            </Loadable>
          </Paper>
        </Col>
      </Row>
    );
  }
}

export default CompanyDataTableView;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/data-table/data-table.view.jsx